import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c661a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-service-filter" }

import { computed, onMounted, PropType, ref, watch } from 'vue'
import BaseSelect from '@/components/BaseSelect.vue'
import { Option } from '@/models/shared.model'
import { fetchSearchCategories } from '@/queries/categories'
import { getOptionKeys } from '@/utils/general'
import { debounce } from 'lodash'
import { PublicService } from '@/models/public/bookingWidget.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteServiceFilter',
  props: {
  services: {
    type: Array as PropType<PublicService[]>,
    required: true,
  },
},
  emits: ['onSearchCategoriesChange'],
  setup(__props, { emit: emits }) {

const props = __props





const debouncedCategoriesChange = debounce((value: string) => {
  emits('onSearchCategoriesChange', value)
}, 400)

const allSearchCategories = ref<{ id: number; name: string }[]>([])
const selectedSearchCategories = ref<Option[]>([])

const searchCategoryOptions = computed(() => {
  return allSearchCategories.value
    .filter((searchCategory) =>
      props.services.some((s) => +s.search_category === searchCategory.id),
    )
    .map((searchCategory) => ({
      key: searchCategory.id,
      label: searchCategory.name,
    }))
})

const removeOption = (option: Option) => {
  selectedSearchCategories.value = selectedSearchCategories.value.filter(
    (o) => o.key !== option.key,
  )
}

onMounted(async () => {
  const data = await fetchSearchCategories()
  allSearchCategories.value = data
})

watch(
  () => props.services,
  () => {
    selectedSearchCategories.value = selectedSearchCategories.value.filter(
      (selected) =>
        searchCategoryOptions.value.some(
          (option) => option.key === selected.key,
        ),
    )
  },
  { deep: true },
)

watch(
  () => selectedSearchCategories.value,
  () => {
    const categoriesString = String(
      getOptionKeys(selectedSearchCategories.value),
    )
    debouncedCategoriesChange(categoriesString)
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseSelect, {
      modelValue: selectedSearchCategories.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSearchCategories).value = $event)),
      label: _ctx.$t('category'),
      options: _unref(searchCategoryOptions),
      multiple: true,
      "return-object": true,
      onRemove: removeOption
    }, null, 8, ["modelValue", "label", "options"])
  ]))
}
}

})